/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const MiddayIcon = props => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 20 20'
			style={{
				enableBackground: 'new 0 0 20 20'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<path d='M9.9 17.5c-.3-.1-.4-.4-.4-.7v-1.3c0-.3.2-.5.5-.5h.1c.2 0 .4.2.4.4V17c0 .2-.2.4-.4.4h-.2zM2.5 9.9c.1-.3.4-.4.7-.4h1.3c.2 0 .5.2.5.5v.1c0 .2-.2.4-.4.4H3c-.2 0-.3-.2-.4-.4v-.2zM10 6c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m2.9 4c0-1.6-1.3-3-2.9-3-1.6 0-3 1.3-3 2.9 0 1.6 1.3 3 2.9 3 1.7 0 3-1.3 3-2.9M10.5 3.8v.8c0 .2-.2.4-.4.5-.3-.1-.5-.2-.6-.4V3.1c0-.3.2-.5.5-.5h.2c.2.1.3.2.3.4v.8zM15.4 14.9c0 .2-.1.4-.3.5-.2.1-.4.1-.5-.1-.4-.4-.8-.7-1.1-1.1-.2-.2-.1-.5.1-.7.2-.2.4-.2.6 0 .4.4.8.7 1.1 1.1.1.1.1.2.1.3M5.1 15.4c-.2 0-.4-.1-.5-.3-.1-.2-.1-.4.1-.5.4-.4.7-.8 1.1-1.1.2-.2.5-.2.7 0 .2.2.2.5 0 .7-.4.4-.7.8-1.1 1.1-.1.1-.2.1-.3.1M4.6 5.1c0-.2.1-.4.3-.5.1-.1.3-.1.5.1.4.3.7.7 1.1 1.1.2.2.2.5 0 .7s-.5.2-.7 0c-.4-.4-.8-.7-1.1-1.1-.1-.1-.1-.2-.1-.3M15.4 5.1c0 .1-.1.2-.2.3-.3.4-.7.7-1 1-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7.3-.4.7-.7 1-1 .1-.1.4-.2.6-.1.2.1.4.3.3.5M16.2 9.5h.8c.3 0 .5.3.5.5s-.1.3-.2.4c-.1.1-.2.1-.3.1h-1.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.6' />
		</svg>
	)
}

export default MiddayIcon
